const textProps = {
  heading2badge: {
    title: "Our Values",
    text:
      "Our values drive our success and shape our positive impact, fostering a culture where we are valued for our ethical conduct, creative solutions, teamwork, high standards, and responsibility.",
    alignment: "center",
  },
  infoAreas: [
    {
      color: "lightBlue",
      icon: "fas fa-dollar-sign",
      title: "Exceptional Value",
      description:
        "We provide top-tier engineering talent at competitive pricing, ensuring you receive the best value for your investment.",
    },
    {
      color: "lightBlue",
      icon: "fas fa-tasks",
      title: "Efficient Practices",
      description:
        "We use streamlined project management methodologies, including Agile and Scrum, to ensure smooth development and outstanding results.",
    },
    {
      color: "lightBlue",
      icon: "fas fa-check-circle",
      title: "Expert Assurance",
      description:
        "We rely on a rigorous employee assessment process to provide experts whose skillsets perfectly match your project requirements.",
    },
    {
      color: "lightBlue",
      icon: "fas fa-users",
      title: "Team Scalability",
      description:
        "Our vast pool of experienced specialists allows you to easily scale your team with the required IT professionals.",
    },
    {
      color: "lightBlue",
      icon: "fas fa-user-check",
      title: "Tailored Solutions",
      description:
        "We value your uniqueness and strive to offer services tailored to the specific needs and goals of each customer.",
    },
    {
      color: "lightBlue",
      icon: "fas fa-lightbulb",
      title: "Innovative Approach",
      description:
        "We embrace cutting-edge technologies and creative solutions to stay ahead and deliver the most advanced outcomes for your projects.",
    }
  ],
};
export default textProps;
